/**
 * The subcontractor's "Submit to prime" control is server-rendered
 * (`app/views/inspections/show.html.erb`, `app/views/work_orders/show.html.erb`) and lives outside
 * this island's React tree, so there is no prop to drive it with — the legacy path reached for the
 * same element by id (`useDocuments.ts#toggleSendToPrimeBtn`).
 *
 * `send_for_review?` gates on there being no missing required document, so every upload and delete
 * can flip it. Nothing on the converted surface re-evaluated it, which left the button disabled
 * after the last required document was uploaded, and — the direction that matters — enabled after a
 * required document was deleted, offering a submit the server then refuses.
 *
 * Isolated here rather than inlined at the call site so the DOM write has one home and can be
 * asserted directly.
 */
export const SUBMIT_TO_PRIME_BUTTON_ID = 'submitToPrimeBtn';
export function setSubmitToPrimeEnabled(enabled) {
    const button = document.getElementById(SUBMIT_TO_PRIME_BUTTON_ID);
    if (!button)
        return; // the prime side renders no such button
    if (enabled) {
        button.removeAttribute('disabled');
    }
    else {
        button.setAttribute('disabled', 'disabled');
    }
}
